import { machine, connect, collection as selectCollection } from '@zag-js/select';
import { useMachine } from '@zag-js/svelte';
import { useConnect } from '../../utils/useConnect.svelte.js';
export const useSelect = (items, props) => {
    const collection = selectCollection({
        items,
        itemToString: (item) => item.label,
        itemToValue: (item) => item.value
    });
    const { value, defaultValue, ...restProps } = props;
    const stateMachine = useMachine(machine, {
        collection,
        ...restProps,
        defaultValue: defaultValue ?? value
    });
    const reactiveConnectApi = useConnect(stateMachine, connect);
    return reactiveConnectApi;
};
